import { FAQAccordion } from '@/components/feature/FAQAccordion';
import { faqs } from '@/mocks/faqs';
import { useFadeUp } from '@/hooks/useFadeUp';

export function FAQSection() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div ref={ref} className="fade-up max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Questions fréquentes</h2>
          <p className="section-subtitle">
            Trouvez rapidement la réponse à vos questions sur la réparation de volets roulants
          </p>
        </div>

        <FAQAccordion items={faqs} />
      </div>
    </section>
  );
}